import { render } from "./Panels.vue?vue&type=template&id=d7595c96&scoped=true"
import script from "./Panels.vue?vue&type=script&lang=js"
export * from "./Panels.vue?vue&type=script&lang=js"

import "./Panels.vue?vue&type=style&index=0&id=d7595c96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7595c96"]])

export default __exports__